import { jsx as _jsx } from "react/jsx-runtime";
import { AppLangCode } from '@libs/types';
import { JurisdictionsEnum } from '@libs/backend-common';
import { BritishFlagIcon, GeorgianFlagIcon, RussianFlagIcon, UkraineFlagIcon, } from '../../assets';
const getLanguageOptions = (jurisdictionId) => {
    const options = [];
    options.push({
        icon: _jsx(BritishFlagIcon, {}),
        label: 'Eng',
        value: AppLangCode.EN,
    });
    if (jurisdictionId === JurisdictionsEnum.GE) {
        options.push({
            icon: _jsx(GeorgianFlagIcon, {}),
            label: 'ქარ',
            value: AppLangCode.KA,
        });
    }
    if ([JurisdictionsEnum.GE, JurisdictionsEnum.UA].includes(jurisdictionId)) {
        options.push({
            icon: _jsx(UkraineFlagIcon, {}),
            label: 'Укр',
            value: AppLangCode.UA,
        }, {
            icon: _jsx(RussianFlagIcon, {}),
            label: 'Рус',
            value: AppLangCode.RU,
        });
    }
    return options;
};
export { getLanguageOptions };
//# sourceMappingURL=LanguageOptions.js.map